import { createLcg } from "../rng/lcg.js";
import { shuffle } from "../rng/shuffle.js";
import type { RunState } from "../types/index.js";

/** プロジェクト開始前に所持カードを山札へまとめ、捨て札の並びを引き継がない。 */
export function prepareCaseDeck(run: RunState): RunState {
  const pile = [
    ...run.deck,
    ...run.discard,
    ...run.hand,
    ...run.inPlay,
    ...run.aside,
    ...(run.caseExcluded ?? []),
  ];
  const rng = createLcg(run.rngState);
  return {
    ...run,
    deck: shuffle(pile, rng),
    discard: [],
    hand: [],
    inPlay: [],
    aside: [],
    caseExcluded: [],
    rngState: rng.state,
  };
}
